import VideoPlayer from '@commons/components/VideoPlayer';
import { asAbsoluteURL } from '@commons/helpers/url';
import type { DrupalBlock, DrupalVideo } from '@commons/types/drupal';

// Type definition for the LocalVideoBlock component properties.

type Props = DrupalBlock<{
  url: string;
  name: string;
  mobileVideo?: DrupalVideo;
  hasMobileVideo?: boolean;
  loop?: boolean;
  autoplay?: boolean;
  startOnMute?: boolean;
  displayControls?: boolean;
  roundCorners?: boolean;
  aspectRatio?: string;
  fullscreen?: boolean;
}>;

/**
 * LocalVideo block component.
 *
 * Supports multiple sources for responsive video handling.
 */

const LocalVideoBlock = ({ content }: Props) => {
  const {
    url,
    mobileVideo,
    hasMobileVideo = false,
    loop = false,
    autoplay = false,
    startOnMute = false,
    displayControls = true,
    roundCorners = true,
    aspectRatio,
    fullscreen = false,
  } = content;

  const desktopSrc = asAbsoluteURL(url);

  const mobileSrc =
    hasMobileVideo && mobileVideo?.url ? asAbsoluteURL(mobileVideo.url) : desktopSrc;

  return (
    <VideoPlayer
      loop={loop}
      muted={startOnMute}
      volume={startOnMute ? 0 : 1}
      playing={autoplay}
      autoPlay={autoplay}
      controls={displayControls}
      playsInline
      fullScreen={fullscreen}
      aspectRatio={aspectRatio ?? '16 / 9'}
      roundCorners={roundCorners}
      className="w-100"
    >
      <source src={desktopSrc} type="video/mp4" media="(min-width: 768px)" />
      <source src={mobileSrc} type="video/mp4" />
    </VideoPlayer>
  );
};

export default LocalVideoBlock;
